// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"25d47d8b","197":"64e61e51","411":"7b2d06fd","493":"94948b3a","541":"3d9fc5f4","618":"43331964","717":"8274568e","912":"03684eb3","933":"31fba30e"}[chunkId] + ".css";
};